import { ChatAttachmentWarning } from '@agent/agent-interface/contact-view/chat/model/chat-attachment-error';
import { ChatProgressInfo } from '@agent/agent-interface/contact-view/chat/model/chat-progress-info';

export class ChatAttachmentInfo {
  public warnings: ChatAttachmentWarning[];
  public validatedFiles: File[];
  public progressResponse: ChatProgressInfo[];

  constructor(warnings: ChatAttachmentWarning[] = [], validatedFiles: File[] = [], progressResponse: ChatProgressInfo[] = []) {
    this.warnings = warnings;
    this.validatedFiles = validatedFiles;
    this.progressResponse = progressResponse;
  }
}
